// extracted by mini-css-extract-plugin
export default {"labelClass":"labelClass---ri_oh"};